<template>
  <div class="footer">
    <div>Mentions légales</div>
    <div>Contacter Idylive</div>
    <div>Press</div>
    <div>Membres</div>
    <div>CGU</div>
    <div>Mode d'emploi</div>
    <div>Copyright 2010-2022</div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: ["inside"],
  data() {
    return {};
  },

  watch: {},

  mounted: async function() {},

  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.footer {
  display: grid;
  grid-auto-flow: column;
  justify-items: center;
  justify-content: center;
  grid-auto-columns: max-content;
  grid-gap: 20px;
  font-weight: bold;
  font-size: 14px;
  position: fixed;
  bottom: 10px;
  left: 0;
  right: 0;
  display: none;
}
</style>
